var osWiseDownloadLink = document.querySelectorAll(".os-wise-download-link");

window.addEventListener(
  "DOMContentLoaded",
  function () {
    if (osWiseDownloadLink) {
      var platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

      for (var idx = 0; idx < osWiseDownloadLink.length; ++idx) {
        var btnAmpJsonArr = osWiseDownloadLink[idx].getAttribute("data-btn-ampjson"),
        btnAmpJson = btnAmpJsonArr ? bsLib.JSONParse(btnAmpJsonArr) : {};

        if (macosPlatforms.indexOf(platform) !== -1) {
          osWiseDownloadLink[idx].href = osWiseDownloadLink[idx].dataset.macurl;
          btnAmpJson.desktop_app_type = 'mac';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          osWiseDownloadLink[idx].href = osWiseDownloadLink[idx].dataset.windowsurl;
          btnAmpJson.desktop_app_type = 'windows';
        }

        osWiseDownloadLink[idx].dataset.btnAmpjson = JSON.stringify(btnAmpJson);

        osWiseDownloadLink[idx].addEventListener(
          "click",
          function () {
            if (macosPlatforms.indexOf(platform) === -1 && windowsPlatforms.indexOf(platform) === -1) {
              new bsAlert({
                alertType: "error",
                timeout: 5000,
                htmlMessage: true,
                text: this.dataset.errormsg
              });
            }
          },
          false
        );
      }
    }
  },
  false
);
